import classnames from "classnames";

import { useRowStyles } from "../commonStyles/tableStyles";
import { AthleteCell } from "../tables/AthleteCell";
import { makeStyles } from "../../providers/makeStyles";
import { EntryStatusBadge } from "../heat/badges/EntryStatusBadge";

const useStyles = makeStyles((theme) => ({
    position: {
        textAlign: "center",
    },
    bib: {
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
            marginLeft: theme.spacing(1),
        },
    },
    rank: {
        "&&": {
            paddingRight: theme.spacing(2),
            textAlign: "center",
        },
    },
}));
export const EntryRow = ({ index, entry, showBib, showRank }) => {
    const classes = { ...useStyles(), ...useRowStyles() };
    const athlete = entry.athlete;

    return (
        <tr>
            <td className={classes.position}>{index + 1}</td>
            {showBib && (
                <td>
                    {entry.bib && (
                        <div className={classnames(classes.bib, "bib")}>
                            {entry.bib}
                        </div>
                    )}
                </td>
            )}
            <AthleteCell
                name={athlete.name}
                image={athlete.image}
                team={entry.teamName}
                badgeComponent={<EntryStatusBadge entryStatus={entry.status} />}
            />
            {showRank && (
                <td className={classes.rank}>{!entry.seed && entry.rank}</td>
            )}
        </tr>
    );
};
